<template>
  <el-form-item :label="isPopupMode ? null : field.label" class="generic-field-text">
    <el-input
      :value="value"
      @input="$emit('input', $event)"
      :placeholder="translatePlaceholder(field.placeholder || field.properties.placeholder)"
      :disabled="field.isDisabled"
      size="small"
    />
  </el-form-item>
</template>

<script>
import placeholderTranslation from '@/mixins/placeholderTranslation'

export default {
  name: 'GenericFieldText',
  mixins: [placeholderTranslation],
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    isPopupMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.generic-field-text {
  width: 100%;
}
</style>
